import { SkinSize } from '../../lib/skin/getSizeSkin/generated/types';
import { VerticalAlignTextPreset } from '../../hooks/useVerticalAlign/types';

import { ParagraphSize } from './types';

export const paragraphStyles: Record<ParagraphSize, VerticalAlignTextPreset> = {
    xs: '12-16',
    s: '14-20',
    mc: '16-20',
    m: '16-24',
    l: '20-28',
};

export const paragraphSizeToSkin: Record<ParagraphSize, SkinSize> = {
    l: 'l',
    m: 'm',
    mc: 's', // Сдвиг из-за наличия размера 16-20 DIRECT-238538
    s: 'xs', // Сдвиг из-за наличия размера 16-20 DIRECT-238538
    xs: '2xs', // Сдвиг из-за наличия размера 16-20 DIRECT-238538
};
